var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10.86 14.62V8.068H9.072V14.62H10.86ZM10.656 5.692C10.464 5.564 10.236 5.5 9.972 5.5C9.7 5.5 9.468 5.564 9.276 5.692C9.092 5.812 9 6.04 9 6.376C9 6.704 9.092 6.932 9.276 7.06C9.468 7.188 9.7 7.252 9.972 7.252C10.236 7.252 10.464 7.188 10.656 7.06C10.848 6.932 10.944 6.704 10.944 6.376C10.944 6.04 10.848 5.812 10.656 5.692Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon_information.0550c7375fab8dcffe829ff3203ed785.svg";
export { ForwardRef as ReactComponent };